export default [
  'business',
  'education',
  'household',
  'medical',
  'other',
];
